import {
  ADD_GOVERNORATE,
  ADD_GOVERNORATE_ERROR,
  ADD_GOVERNORATE_SUCCESS,
  GET_GOVERNORATE,
  GET_GOVERNORATES,
  GET_GOVERNORATES_ERROR,
  GET_GOVERNORATES_SUCCESS,
  GET_GOVERNORATE_ERROR,
  GET_GOVERNORATE_SUCCESS,
  TOGGLE_GOVERNORATE_MODAL,
  UPDATE_GOVERNORATE,
  UPDATE_GOVERNORATE_ERROR,
  UPDATE_GOVERNORATE_SUCCESS,
  GET_GOVERNORATES_SELECT_LIST_SUCCESS,
} from "./actionTypes";

const initialState = {
  // governorates
  loadingGovernorates: false,
  loadingGovernoratesSuccess: false,
  loadingGovernoratesError: null,
  governorates: {},
  // add governorate
  governorate: {},
  addGovernorateLoading: false,
  addGovernorateError: null,
  addGovernorateSuccess: false,
  // get governorate
  getGovernorateLoading: false,
  getGovernorateError: null,
  getGovernorateSuccess: null,
  // update governorate
  updateGovernorateLoading: false,
  updateGovernorateError: null,
  updateGovernorateSuccess: null,
  // select list
  governoratesSelectList: [],
};

const governorates = (state = initialState, action) => {
  switch (action.type) {
    case GET_GOVERNORATES:
      state = {
        ...state,
        addGovernorateSuccess: false,
        updateGovernorateSuccess: false,
        loadingGovernorates: true,
        loadingGovernoratesSuccess: false,
        loadingGovernoratesError: null,
        governorates: [],
        governorate: {},
      };
      break;
    case GET_GOVERNORATES_SUCCESS:
      state = {
        ...state,
        loadingGovernorates: false,
        loadingGovernoratesSuccess: true,
        loadingGovernoratesError: null,
        governorates: action.payload,
      };
      break;
    case GET_GOVERNORATES_ERROR:
      state = {
        ...state,
        loadingGovernoratesError: action.payload,
        loadingGovernorates: false,
        loadingGovernoratesSuccess: false,
        governorates: [],
      };
      break;
    case ADD_GOVERNORATE:
      state = {
        ...state,
        addGovernorateLoading: true,
        addGovernorateError: null,
        addGovernorateSuccess: false,
      };
      break;
    case ADD_GOVERNORATE_SUCCESS:
      state = {
        ...state,
        addGovernorateLoading: false,
        addGovernorateError: null,
        addGovernorateSuccess: true,
        governorate: {},
      };
      break;
    case ADD_GOVERNORATE_ERROR:
      state = {
        ...state,
        addGovernorateLoading: false,
        addGovernorateError: action.payload,
        addGovernorateSuccess: false,
      };
      break;
    case GET_GOVERNORATE:
      state = {
        ...state,
        governorate: {},
        getGovernorateLoading: true,
        getGovernorateSuccess: false,
        getGovernorateError: null,
      };
      break;
    case GET_GOVERNORATE_SUCCESS:
      state = {
        ...state,
        getGovernorateError: null,
        getGovernorateSuccess: true,
        getGovernorateLoading: false,
        governorate: action.payload,
      };
      break;
    case GET_GOVERNORATE_ERROR:
      state = {
        ...state,
        getGovernorateError: action.payload,
        getGovernorateLoading: false,
        getGovernorateSuccess: false,
      };
      break;
    case UPDATE_GOVERNORATE:
      state = {
        ...state,
        updateGovernorateLoading: true,
        updateGovernorateError: null,
        updateGovernorateSuccess: false,
      };
      break;
    case UPDATE_GOVERNORATE_SUCCESS:
      state = {
        ...state,
        updateGovernorateLoading: false,
        updateGovernorateError: null,
        updateGovernorateSuccess: true,
      };
      break;
    case UPDATE_GOVERNORATE_ERROR:
      state = {
        ...state,
        updateGovernorateLoading: false,
        updateGovernorateError: action.payload,
        updateGovernorateSuccess: false,
        governorate: {},
      };
      break;
    case GET_GOVERNORATES_SELECT_LIST_SUCCESS:
      state = {
        ...state,
        governoratesSelectList: action.payload,
      };
      break;
    case TOGGLE_GOVERNORATE_MODAL:
      state = {
        ...state,
        governorate: {},
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default governorates;
